import React, { createContext, useContext, useState, useMemo,Suspense }  from 'react'
import { Link as RouterLink, useLoaderData,createBrowserRouter, createRoutesFromElements, defer, Routes, Route, useNavigate, Navigate, useOutlet, Await } from 'react-router-dom'
import App from '../../index'
import Home from '@mui/icons-material/Home'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import Person from '@mui/icons-material/Person'
import Settings from '@mui/icons-material/Settings'
import LinearProgress from '@mui/material/LinearProgress'
import Alert from '@mui/material/Alert'
import Avatar from '@mui/material/Avatar'
import TextField from '@mui/material/TextField'
import Link from '@mui/material/Link'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Button from '@mui/material/Button'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import MenuIcon from '@mui/icons-material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { MdEdit } from 'react-icons/md'
import { IoMdClose,IoIosLogOut } from 'react-icons/io'
export const useLocalStorage = (keyName, defaultValue) => {
    const [storedValue, setStoredValue] = useState(() => {
      try {
        const value = window.localStorage.getItem(keyName)
        if (value) {
          return JSON.parse(value)
        } else {
          window.localStorage.setItem(keyName, JSON.stringify(defaultValue))
          return defaultValue
        }
      } catch (err) {
        return defaultValue
      }
    })
    const setValue = (newValue) => {
      try {
        window.localStorage.setItem(keyName, JSON.stringify(newValue))
      } catch (err) {
        console.log(err)
      }
      setStoredValue(newValue)
    }
    return [storedValue, setValue]
}
const AuthContext = createContext()
export const AuthProvider = ({children}) => {
  const [user2, setUser2] = useLocalStorage('user', null)
  const [auth2FA2, setAuth2FA2] = useState(null)
  const navigate = useNavigate()
  const login = async (data) => {
    setUser2(data)
    navigate('/login-sample-demo/2fa')
  }  
  const auth2FA1 = async (x) => {
    setAuth2FA2('true')
    navigate('/login-sample-demo/dashboard/profile', { replace: true })
  }
  const logout = () => {
    setUser2(null)
    setAuth2FA2(null)
    navigate('/login-sample-demo', { replace: true })
  }

  const value = useMemo(
    () => ({
      user2,
      auth2FA2,
      login,
      logout,
      auth2FA1,
    }),
    [user2, auth2FA2]
  )
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
export const useAuth = () => {
  return useContext(AuthContext)
}
export const AppBar = ({ pages }) => {
    const [anchorElNav, setAnchorElNav] = React.useState(null)
    const navigate = useNavigate()
    const { user2, auth2FA2, logout } = useAuth()
    const handleOpenNavMenu = (event) => {
      setAnchorElNav(event.currentTarget)
    }
    const handleCloseNavMenu = (path) => {
      setAnchorElNav(null)
      if (path) {
        navigate(path)
      }
    }
    const onClick2RemoveTicket = () => { 
      localStorage.clear()
      setTimeout(() => {
        navigate('/')
        window.location.reload()
      }, 1)
 }
    return (
      <div className='flex primary-nav-bar'>
        <div>
        <span className="primary-nav-bar-logo box-decoration-clone bg-gradient-to-r from-indigo-600 to-pink-500 text-white px-2">React JS,TS<br />Parts and Functions</span>
        </div>
        <div className='primary-nav-bar-item flex'>
            <div><button onClick={onClick2RemoveTicket}>Finish DEMO</button></div>
            <div><a href='/login-sample-demo'>Home</a></div>
            <div><a href='/'>Menu</a></div>
            {user2 && auth2FA2 ?<>
                {pages?.map((page) => (
            <div>
                <button onClick={() => handleCloseNavMenu(page.path)}>{page.label}</button>
            </div>
            ))} 
            {/* <div><a href='/login-sample-demo/dashboard/profile'>Profile</a></div><div><a href='/login-sample-demo/dashboard/setting'>Setting</a></div> */}
            <div><button onClick={logout}>Logout</button></div>
             
            </>:<div><a href='/login-sample-demo/login'>Login</a></div>}
             {/* <IconButton
            size='large'
            aria-label='account of current user'
            aria-controls='menu-appbar'
            aria-haspopup='true'
            onClick={handleOpenNavMenu}
            color='inherit'
            >
            <MenuIcon />
            </IconButton>
            <Menu
                id='menu-appbar'
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left'
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left'
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: 'block', md: 'none' }
                }}
            >
            {pages?.map((page) => (
            <MenuItem
                key={page.label}
                onClick={() => handleCloseNavMenu(page.path)}
            >
                <Typography textAlign='center'>{page.label}</Typography>
            </MenuItem>
            ))} 
            {!!user2 && !!auth2FA2 && (
            <MenuItem key={'logout'} onClick={logout}>
            <Typography textAlign='center'>Logout</Typography>
            </MenuItem>
            )} </Menu>*/}
            
            
        </div>
            {/* <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            //   {pages?.map((page) => (
            //     <Button
            //       key={page.label}
            //       onClick={() => handleCloseNavMenu(page.path)}
            //       sx={{ my: 2, color: 'white', display: 'block' }}
            //     >
            //       {page.label}
            //     </Button>
            //   ))}
            //   {/* {!!user2 && !!auth2FA2 && (
            //     <Button
            //       key={'logout'}
            //       onClick={logout}
            //       sx={{ my: 2, color: 'white', display: 'block' }}
            //     >
            //       {'logout'}
            //     </Button>
            //   )} */}
      </div>
    )
} 
const getUserData = () =>
  new Promise((resolve) =>
    setTimeout(() => {
      const user = window.localStorage.getItem('user')
      resolve(user)
    }, 3000)
)
export const MainLayout = () => {
    //const { user2, auth2FA1 } = useAuth()
    const outlet = useOutlet()
    // if (user2 && auth2FA1) {
    //   return <Navigate to='/dashboard/profile' replace/>
    // }
    return (
      <div className='contents'>
        <AppBar
          pages={[
            { label: 'Main', path: '/login-sample-demo' },
            { label: 'Login', path: '/login-sample-demo/login' }
          ]}
        />
        {outlet}
      </div>
    )
}
export const AuthLayout = () => {
    const outlet = useOutlet()
    const { userPromise } = useLoaderData()
    return (
      <Suspense fallback={<LinearProgress />}>
        <Await
          resolve={userPromise}
          errorElement={<Alert severity="error">Something went wrong!</Alert>}
          children={(user) => (
            <AuthProvider userData={user}>{outlet}</AuthProvider>
          )}
        />
      </Suspense>
    )
}
export const ProtectedLayout = () => {
    const { user2, auth2FA2 } = useAuth()
    const outlet = useOutlet()
    console.log(user2, auth2FA2)
    if (!user2) {
        return <Navigate to="/login" />
    }
    else if(!auth2FA2) {
      return <Navigate to="/verify-2fa" />
    } 
    return (
      <div className='contents'>
        <AppBar
          pages={[
            { label: "Profile", path: "profile" },
            { label: "Setting", path: "setting" }
          ]}
        />
        {outlet}
      </div>
    )
}
export const BasicPage = ({ title, icon }) => {
    return (
      <Container component='main' maxWidth='xs'>
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom:200
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>{icon}</Avatar>
          <Typography component='h1' variant='h5'>
            {title}
          </Typography>
        </Box>
      </Container>
    )
}
export const TestPage = () => {
  return <>test</>
}
export const MainPage = () => {
  return <BasicPage title='Main' icon={<Home/>}/>
}
export const TwoFAPage = () => {
    const {auth2FA1} = useAuth()
    const [code, setCode] = useState('')
    const onSubmit22FA = async (e) => {
      e.preventDefault()
      if (code === '1') {
        await auth2FA1({ code })
      } else {
        alert('Invalid code. Please try again.')
      }
    }
    return (
      <form onSubmit={onSubmit22FA}>
        <input
          type= 'text'
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder= 'Enter verification code'
        />
        <button type='submit'>Verify</button>
      </form>
    )
}
export const LoginPage = () => {
  const [email, setEmail] = useState('')
  const [pwd, setPwd] = useState('')
  const { login } = useAuth()
  const onSubmit2Login = async (e) => {
    e.preventDefault()
    console.log('email, pwd',email,pwd)
    if (email === '1@gmail.com' && pwd === '1') {
      await login({ email })
    } else {
      alert('Invalid email or pwd')
    }
  }
  return (
  <Container component='main' maxWidth='xs'>
  <Box
    sx={{
      marginTop: 8,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}
  >
    <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
      <LockOutlinedIcon />
    </Avatar>
    <Typography component='h1' variant='h5'>
      Log In
    </Typography>
    <Box component='form' onSubmit={onSubmit2Login} noValidate sx={{ mt: 1 }}>
      <TextField
        margin='normal'
        required
        fullWidth
        id='email'
        label='Email Address'
        name='email'
        autoComplete='email'
        autoFocus
        onChange={(e) => setEmail(e.target.value)}
      />
      <TextField
        margin='normal'
        required
        fullWidth
        name='password'
        label='Password'
        type='password'
        id='password'
        autoComplete='current-password'
        onChange={(e) => setPwd(e.target.value)}
      />
      <Button
        type='submit'
        fullWidth
        variant='contained'
        sx={{ mt: 3, mb: 2 }}
      >
        Login
      </Button>
      <Grid container>
        <Grid item>
          <RouterLink to='/register'>
            <Link href='#' variant='body2'>
              {'Don\'t have an account? Sign Up'}
            </Link>
          </RouterLink>
        </Grid>
      </Grid>
    </Box>
  </Box>
</Container>
  )
}
export const ProfilePage = () => {
    return <BasicPage title='Profile page' icon={<Person/>}/>
}
export const SettingPage = () => {
    return <BasicPage title='Settings page' icon={<Settings/>}/>
}
export default function Login() {
  const [editMode, setEditMode] = useState(false)
  const [updateItem, setUpdateItem] = useState()
  const [list1, setList1] = useState([
    {
      id: '1',
      email: '1@gmail.com',
      password: '1',
     
      // username:'Don Joe1',
      // phonenumber:'',
      // role: 'admin',
    },
    {
      id: '2',
      email: '2@gmail.com',
      password: '2',
      // username:'Don Joe2',
      // phonenumber:'',
      // role: 'user',
    }
  ])
  const [email, setEmail] = useState()
  const [password, setPassword] = useState()
  //user useState
  const [loginInput, setLoginInput] = useState({})
  const [loginErr, setLoginErr] = useState(null)
  const [login, setLogin] = useState(false) 
  const [signup, setSignup] = useState(false)
  const [updateList, setUpdateList] = useState()
  const pages = [
    {},
    {},
    {}
  ]
//   const routes = useRoutes([
//     {
//       path: "/",
//       element: <HomePage />
//     }
//     // {
//     //   path: "/login",
//     //   element: <LoginPage />
//     // },
//     // {
//     //   path: "/profile",
//     //   element: <ProfilePage />
//     // }
//   ])
  //user
  const onChange2Input1 = ({ currentTarget: x }) => { setLoginInput({ ...loginInput, [x.name]: x.value }) }
  const onClick2Create = () => {
    setLoginErr(null)
    let findEmail = list1.find((x) => x.email ==loginInput.email)
    console.log(findEmail==undefined)
    if(findEmail==undefined){
       //add loginInput.email ,loginInput.password to list1
       //setList1(updateList)
       setList1((x) => [
         ...x,
         {
           id: Math.random().toString(),
           email:loginInput.email,
           password:loginInput.password
           // role
         },
       ])
       setSignup(!signup)
       setLogin(!login)

       //   if(findEmail.password ==loginInput.password){
       //     console.log('login succeeded')
       //     setLogin(!login)
       //   }else{
       //     setLoginErr('Your password is not matched.')
       //   } 
      }else{
        setLoginErr('Your email is already in use. Please use another email.')
      }
  }
  const onClick2Login = () => {
    setLoginErr(null)
    let findEmail = list1.find((x) => x.email ==loginInput.email)
    if(findEmail!='undefined'){
      if(findEmail.password ==loginInput.password){
        setLogin(!login)
      }else{
        setLoginErr('Your password is not matched.')
      }
    }else{
      setLoginErr('Your email is not found.')
    }
  }
  //admin
  const onClick2delete = (dataId) => {
    setList1((x) => {
      return x.filter((x) => x.id !== dataId)
    })
  }
  const onClick2Edit = () => {
    setUpdateList(list1)
    setEditMode(!editMode)
  }
  const onSubmit2Update = (data1) => {
    setList1(updateList)
    setEditMode(!editMode)
  } 
  const onChange2Input2 = ({currentTarget:y}, x) => {
    var b1 = [...updateList]
    var b2 = updateList.filter((w) => w.id === x)[0]
    var i = updateList.indexOf(b2)
    setUpdateItem({...b2, [y.name]:y.value})
    b1[i] = {...b2, [y.name]:y.value}
    list3(b1)
  }
  const list3 = (list2) => {
    setUpdateList(list2)
    window.localStorage.setItem('list2', JSON.stringify(list2))
  }
  const onClick2Add = (e) => {
    e.preventDefault()
    setList1((x) => [
      ...x,
      {
        id: Math.random().toString(),
        email,
        password
        // role
      },
    ])
  }
      return (
        <></>
        // <AuthProvider>
        // <Routes>
        //   {/* <Route
        //     element={<AuthLayout />}
        //     loader={() => defer({ userPromise: getUserData() })}
        //   > */}
        //   <Route path='/' element={<App />} />
        //   {/* </Route> */}
        //   <Route path='/1' element={<TestPage />} />
        //     {/* <Route element={<MainLayout />}>
        //      {/* <Route path='/' element={<App />} /> 
        //      <Route path='/login-sample-demo' element={<MainPage />}/>
        //      <Route path='/login-sample-demo/2fa' element={<TwoFAPage />} />
        //      <Route path='/login-sample-demo/login' element={<LoginPage />} /> 
        //     </Route>
        //     <Route path='/login-sample-demo/dashboard' element={<ProtectedLayout />}>
        //      <Route path='profile' element={<ProfilePage />} />
        //      <Route path='setting' element={<SettingPage />} />
        //     </Route> */}
        // </Routes>
      //    <Route
      //   path="/secret"
      //   element={
      //     <ProtectedRoute auth2FA7={auth2FA6}>
      //       <Secret/>
      //     </ProtectedRoute>
      //     }
      // /> 
        // </AuthProvider>
        //<Routes>
        // {/* <Route element={<HomeLayout />} /> */}
        //  <Route path="/a" element={<HomePage />} />
        //  {/*  */}
        // {/* */}
        // {/* </Route>
        // <Route path="/dashboard" element={<ProtectedLayout />}> */}
        //     {/* <Route path="/profile" element={<ProfilePage />} />
        //     <Route path="/setting" element={<SettingPage />} /> */}
        // {/* </Route> */}
        // {/* <Route
        //     path="/secret"
        //     element={
        //     <ProtectedRoute auth2FA7={auth2FA6}>
        //         <Secret/>
        //     </ProtectedRoute>
        //     }
        // /> */}
        // </Routes>
        // <div className='text-center p-1'>
        // <b>1-1 Login js</b><br/>
        // <div className='multi-all-output-form-lg flex flex-col'>
        //  {login?<>
        //  <div className='flex justify-between'><h4>main page</h4> <br/><IoIosLogOut onClick={(x)=>setLogin(!login)}/></div>
        //  {signup?<>
        //   <label className='primary-label' >email</label>
        //   <input className='primary-input' type='email' name='email' defaultValue={loginInput.email} onChange={onChange2Input1} />
        //   <label className='primary-label'>password</label>
        //   <input className='primary-input' type='text' name='password' defaultValue={loginInput.password} onChange={onChange2Input1} />
        //   {loginErr!=null?<p className='text-red-700'>{loginErr}</p>:''}
        //   <div className='flex justify-center'>
        //     <button className='primary-btn mt-1' >Update</button>
        //   </div>
        //   <u onClick={(x)=>setSignup(!signup)} className='cursor-default'>Cancel</u>
        //   </>:<><u onClick={(x)=>setSignup(!signup)} className='cursor-default'>Account information</u>
        //   </>}<u>Remove your account</u> {/* //modal shows to ask deleting account */}

        //  </>:<>{signup?<> create new account<br/>
        //   <label className='primary-label' >email</label>
        //   <input className='primary-input' type='email' name='email' defaultValue={loginInput.email} onChange={onChange2Input1} />
        //   <label className='primary-label'>password</label>
        //   <input className='primary-input' type='text' name='password' defaultValue={loginInput.password} onChange={onChange2Input1} />
        //   {loginErr!=null?<p className='text-red-700'>{loginErr}</p>:''}
        //   <div className='flex justify-center'><button className='primary-btn mt-1' onClick={onClick2Create}>Create</button></div>
        //   <div className='flex justify-center'><button className='text-xs' onClick={(x)=>setSignup(!signup)}>
        //   <u>Already have an account?</u>
        //   </button></div>
        //   </>:<>login<br/>
        //   <label className='primary-label' >email</label>
        //   <input className='primary-input' type='email' name='email' defaultValue={loginInput.email} onChange={onChange2Input1} />
        //   <label className='primary-label'>password</label>
        //   <input className='primary-input' type='text' name='password' defaultValue={loginInput.password} onChange={onChange2Input1} />
        //   {loginErr!=null?<p className='text-red-700'>{loginErr}</p>:''}
        //   <div className='flex justify-center'><button className='primary-btn mt-1' onClick={onClick2Login}>Login</button></div>
        //   <div className='flex justify-center'><button
        //     className='text-xs'
        //     onClick={(x)=>setSignup(!signup)}
        //   >
        //     <u>Create new account</u>
        //   </button></div></>}</>} 
        // </div>
        // <div className='multi-all-output-form-sm'>
        //   admin menu
        // {list1.map((x) => (
        //   <>
        //     {editMode ? (
        //      <div className='m-2'> 
        //      <div>
        //        <div className='multi-input-form-row1 mb-1'>
        //          <span>Email: </span>
        //          <input
        //            type='email'
        //            name='email'
        //            className='text-input-width'
        //            defaultValue={x.email}
        //            onChange={(y)=>onChange2Input2(y, x.id)}
        //          />
        //        </div>
        //        <div className='multi-input-form-row1 mb-1'>
        //          <span>Password: </span>
        //          <input
        //          className='text-input-width'
        //          name='password'
        //          defaultValue={x.password}
        //          onChange={(y)=>onChange2Input2(y, x.id)}
        //           />
        //        </div>
        //        {/* <div>
        //          <span>Role: </span>
        //          <select
        //             name='role'
        //            className='border-0 todo-select'
        //            defaultValue={x.role}
        //            onChange={(y)=>onChange2Input2(y, x.id)}
        //            placeholder='Please select'
        //          >
        //            <option value=''>Select</option>
        //            <option value='admin'>admin</option>
        //            <option value='user'>user</option>
        //          </select>
        //        </div> */}
        //      </div>
        //  </div>
        //     ) : (
        //       <div key={x.id}>
        //         <div className='text-right'>
        //           <button className='ml-1 mr-2' onClick={onClick2delete.bind(null, x.id)}><IoMdClose/></button>
        //         </div>
        //         <span>Email: {x.email}</span>
        //         <br />
        //         <span>Password: {x.password}</span>
        //         {/* <span>Role: {x.role}</span> */}
        //       </div>
        //     )}
        //   </>
        // ))}
        //   <div className='mb-2 flex justify-end'>{editMode ?     
        //     <form onSubmit={onSubmit2Update} ><button type='submit' className='mr-2'>
        //       Save
        //     </button><button type='button' onClick={e=>setEditMode(!editMode)}>Cancel</button>
        //   </form>:<><button onClick={onClick2Edit} className='edit-tool1'><MdEdit /></button><button className='primary-btn edit-tool2' onClick={onClick2Add}
        //   >Create new account</button></>}</div>
        // </div> 
        // </div>
      )
}
// export const router = createBrowserRouter(
//     createRoutesFromElements(
//       <>
//       <Route
//         element={<AuthLayout />}
//         loader={() => defer({ userPromise: getUserData() })}
//       >
//         <Route element={<MainLayout />}>
//           <Route path='/login-sample-demo' element={<MainPage />} />
//           <Route path='/' element={<App />} />
//           <Route path='/login-sample-demo/login' element={<LoginPage />} />
//           <Route path='/login-sample-demo/2fa' element={<TwoFAPage />} />
//         </Route>
//        <Route path='/login-sample-demo/dashboard' element={<ProtectedLayout />}>
//           <Route path='profile' element={<ProfilePage />} />
//           <Route path='setting' element={<SettingPage />} />
//         </Route> 
//       </Route>
//       </>
//     )
// )
//to show login function demo
export const TestPage1 = () => {
  return <>test1</>
}
export const TestPage2 = () => {
  return <>test2</>
}
export function App2() {
  return (
       <>
       <AuthProvider>
       <Routes>
       <Route path='/1' element={<TestPage1 />} />
       <Route path='/2' element={<TestPage2 />} />
       <Route element={<MainLayout />}>
       <Route path='/' element={<Navigate to='/login-sample-demo' />} /> 
       <Route path='/login-sample-demo' element={<MainPage />}/>
       <Route path='/login-sample-demo/2fa' element={<TwoFAPage />} />
       <Route path='/login-sample-demo/login' element={<LoginPage />} /> 
       </Route>
       <Route path='/login-sample-demo/dashboard' element={<ProtectedLayout />}>
       <Route path='profile' element={<ProfilePage />} />
       <Route path='setting' element={<SettingPage />} />
       </Route>
       </Routes>
       </AuthProvider>
       </>
  )     
}